import { styled as w } from "@mui/material";
import * as v from "ramda";
import { forwardRef as y, useRef as I, useState as b, useEffect as c, useCallback as k, useImperativeHandle as L } from "react";
import { jsx as R } from "react/jsx-runtime";
const C = w("video")`
  pointer-events: none;
`, E = (u, f) => {
  const o = I(null), {
    className: m,
    deferUntilIdle: n = !1,
    playbackRate: a = 1,
    src: i,
    ...l
  } = u, [s, r] = b(!n);
  c(() => {
    if (!n) {
      r(!0);
      return;
    }
    let t, e;
    const d = () => {
      window.requestIdleCallback ? t = window.requestIdleCallback(() => r(!0), {
        timeout: 2e3
      }) : e = window.setTimeout(() => r(!0), 200);
    };
    return document.readyState === "complete" ? d() : window.addEventListener("load", d, {
      once: !0
    }), () => {
      window.removeEventListener("load", d), t !== void 0 && window.cancelIdleCallback(t), e !== void 0 && window.clearTimeout(e);
    };
  }, [n]), c(() => {
    v.isNotNil(o.current) && (o.current.playbackRate = a);
  }, [a, s, i]);
  const p = k((t) => {
    const e = t.target;
    e.currentTime = 0, e.play();
  }, []);
  return L(f, () => o.current), /* @__PURE__ */ R(C, {
    ...l,
    className: m,
    autoPlay: !0,
    muted: !0,
    controls: !1,
    playsInline: !0,
    ref: o,
    preload: n ? "none" : l.preload,
    src: s ? i : void 0,
    onEnded: p
  });
}, T = y(E);
export {
  T as default
};
//# sourceMappingURL=ApeironLoopVideo.js.map
